module.exports = __webpack_public_path__ + "static/img/title.acb9092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title.png
// module id = k7BE
// module chunks = 1